var React = require('react');

function ConfirmCheckmark (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Selected"},React.createElement("path",{"id":"Vector 420 (Stroke)","fillRule":"evenodd","clipRule":"evenodd","d":"M14.7071 3.29289C15.0976 3.68342 15.0976 4.31658 14.7071 4.70711L6 13.4142L1.29289 8.70711C0.902369 8.31658 0.902369 7.68342 1.29289 7.29289C1.68342 6.90237 2.31658 6.90237 2.70711 7.29289L6 10.5858L13.2929 3.29289C13.6834 2.90237 14.3166 2.90237 14.7071 3.29289Z","fill":"#E8EFFF"})));
}

ConfirmCheckmark.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ConfirmCheckmark;

ConfirmCheckmark.default = ConfirmCheckmark;
